package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.data.repository.MatchRepository
import br.com.texeratx.boardgametimeapp.ui.screens.matches.MatchesViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.matches.edit.MatchEditViewModel
import org.koin.dsl.module

val matchesModule = module {
    factory { MatchRepository(get(), get()) }
    factory { MatchesViewModel(get()) }
    factory { MatchEditViewModel(
        get(),
        get(),
        get(),
        get()
    ) }

}